import React from 'react';
import PropTypes from 'prop-types';
import { CHART_CARD_SURFACE, getBoardChartCardClass } from './chartCard.js';

const StatisticsChartCardResizeHandle = ({ surface, canResizeWidth, onResizePointerDown }) => {
	const boardClass = getBoardChartCardClass(surface);
	if (!canResizeWidth || !boardClass?.resizeHandle) return null;

	return (
		<div
			className={boardClass.resizeHandle}
			role='separator'
			aria-orientation='vertical'
			aria-label='拖拽调整卡片宽度'
			title='拖拽调整宽度'
			onPointerDown={onResizePointerDown}
		/>
	);
};

StatisticsChartCardResizeHandle.propTypes = {
	surface: PropTypes.oneOf(Object.values(CHART_CARD_SURFACE)),
	canResizeWidth: PropTypes.bool,
	onResizePointerDown: PropTypes.func,
};

export default StatisticsChartCardResizeHandle;
